module.exports = __webpack_public_path__ + "img/51.1.84eb56d6.jpg";